import {
	Component, Input, OnDestroy, OnChanges, AfterViewInit, ViewChild, SimpleChanges, Output, EventEmitter,
	ChangeDetectorRef, OnInit, ElementRef
} from '@angular/core';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';


@Component({
	selector: 'port-enable-disable-dialog',
	templateUrl: './port-enable-disable-dialog.component.html',
	styleUrls: ['./port-enable-disable-dialog.component.scss']
})
export class PortEnableDisableDialogComponent implements OnChanges, OnDestroy, OnInit, AfterViewInit {

	@Input()
	public deviceGuid: string;

	@Input()
	public visible: boolean;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	public ifTableHeightPx: number;
	private resizeObserver: ResizeObserver;

	public get ifTableHeightPxProp(): number {
		return this.ifTableHeightPx;
	}

	constructor(private elemRef: ElementRef,
		private changeDetector: ChangeDetectorRef,
		@Inject(DOCUMENT) private document: Document) {

		this.deviceGuid = undefined;
		this.visible = false;
		this.visibleChange = new EventEmitter<boolean>();
		this.ifTableHeightPx = 330;
		this.resizeObserver = null;
	}

	private connectResizeObserver(): void {
		let dialogDiv = <HTMLDivElement>this.document.querySelector(".port-status-dialog");
		this.resizeObserver = new ResizeObserver((entries) => this.onResize(entries))
		this.resizeObserver.observe(dialogDiv);
	}

	private disconnectResizeObserver(): void {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
			this.resizeObserver = null;
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes["visible"]) {
			if (!this.visible) {
				this.disconnectResizeObserver();
			}
		}
	}

	public ngOnInit(): void {

	}

	public ngAfterViewInit(): void {

	}

	public ngOnDestroy(): void {

	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public onCloseClicked(): void {
		this.onHide();
	}

	public onShow(): void {
		this.disconnectResizeObserver();
		this.connectResizeObserver();
	}

	public onHide(): void {
		this.disconnectResizeObserver();
		this.hide();
	}

	public onResize(entries: any): void {
		//console.log(entries[0].contentRect.height);
		this.ifTableHeightPx = entries[0].contentRect.height - 470;
		//console.log(this.ifTableHeightPx);
		this.changeDetector.markForCheck();
		setTimeout(() => {
			this.changeDetector.detectChanges();
		}, 0);
	}
}
